module.exports = __webpack_public_path__ + "static/media/sp-reservation-title-inquiry@2x.725c9708.png";